import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["button_title", "button_icon", "badge_title", "badge_subtitle", "promoted"],
      _excluded2 = ["web_button_title", "badge_title", "badge_subtitle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export const transformProfile = dto => dto;
export const transformClosetPromo = _ref => {
  let {
    button_title,
    button_icon,
    badge_title,
    badge_subtitle,
    promoted
  } = _ref,
      profile = _objectWithoutProperties(_ref, _excluded);

  return _objectSpread(_objectSpread({}, transformProfile(profile)), {}, {
    buttonTitle: button_title,
    buttonIcon: button_icon,
    badgeTitle: badge_title,
    badgeSubtitle: badge_subtitle,
    isPromoted: !!promoted
  });
};
export const transformClosetPromoContainer = _ref2 => {
  let {
    closet_promotion_banners
  } = _ref2;
  return {
    closetPromotionBanners: closet_promotion_banners.map(transformClosetPromo)
  };
};
export const transformFeedPersonalization = _ref3 => {
  let {
    title,
    subtitle,
    action_title,
    bottom_title,
    bottom_subtitle,
    bottom_action_title
  } = _ref3;
  return {
    title,
    subtitle,
    actionTitle: action_title,
    bottomTitle: bottom_title,
    bottomSubtitle: bottom_subtitle,
    bottomActionTitle: bottom_action_title
  };
};
export const transformNps = _ref4 => {
  let {
    question_title,
    open_question_title,
    score_explanation
  } = _ref4;
  return {
    questionTitle: question_title,
    openQuestionTitle: open_question_title,
    scoreExplanation: score_explanation
  };
};
export const transformFullNameConfirmation = _ref5 => {
  let {
    button_title,
    hint,
    placeholder,
    real_name,
    subtitle,
    title
  } = _ref5;
  return {
    buttonTitle: button_title,
    hint,
    placeholder,
    realName: real_name,
    subtitle,
    title
  };
};
export const transformPushUp = _ref6 => {
  let {
    web_button_title,
    badge_title,
    badge_subtitle
  } = _ref6,
      profile = _objectWithoutProperties(_ref6, _excluded2);

  return _objectSpread(_objectSpread({}, transformProfile(profile)), {}, {
    webButtonTitle: web_button_title,
    badgeTitle: badge_title,
    badgeSubtitle: badge_subtitle
  });
};
export const transformTermsAndConditions = _ref7 => {
  let {
    title,
    subtitle,
    button_title
  } = _ref7;
  return {
    title,
    subtitle,
    buttonTitle: button_title
  };
};
export const transformPortalMergeFeed = _ref8 => {
  let {
    heading,
    text,
    cta_title,
    cta_url
  } = _ref8;
  return {
    heading,
    text,
    buttonTitle: cta_title,
    buttonUrl: cta_url
  };
};
export const transformPortalMergeAnnouncement = _ref9 => {
  let {
    animation_url,
    image_url,
    heading,
    text,
    text_link_title,
    text_link_url,
    cta_title,
    cta_url,
    close_title,
    close_url
  } = _ref9;
  return {
    animationUrl: animation_url,
    imageUrl: image_url,
    heading,
    text,
    textLinkTitle: text_link_title,
    textLinkUrl: text_link_url,
    primaryActionTitle: cta_title,
    primaryActionUrl: cta_url,
    closeActionTitle: close_title,
    closeActionUrl: close_url !== null && close_url !== void 0 ? close_url : undefined
  };
};
export const transformMergeWelcomeScreen = _ref10 => {
  let {
    image_url,
    heading,
    text,
    text_link_title,
    text_link_url,
    main_cta_title,
    main_cta_url,
    secondary_web_cta_title
  } = _ref10;
  return {
    animationUrl: undefined,
    imageUrl: image_url,
    heading,
    text,
    textLinkTitle: text_link_title,
    textLinkUrl: text_link_url,
    primaryActionTitle: main_cta_title,
    primaryActionUrl: main_cta_url,
    closeActionTitle: secondary_web_cta_title
  };
};
export const transformPortalMergeDataMigration = _ref11 => {
  let {
    cta_title,
    heading,
    text
  } = _ref11;
  return {
    heading,
    text,
    ctaTitle: cta_title
  };
};
export const transformGoToOldPortalBanner = _ref12 => {
  let {
    image_url,
    heading,
    text,
    main_cta_title,
    main_cta_url,
    secondary_cta_title,
    secondary_cta_url
  } = _ref12;
  return {
    animationUrl: undefined,
    heading,
    text,
    imageUrl: image_url,
    primaryActionTitle: main_cta_title,
    primaryActionUrl: main_cta_url || undefined,
    closeActionTitle: secondary_cta_title,
    closeActionUrl: secondary_cta_url || undefined
  };
};
export const transformListerActivationBanner = _ref13 => {
  let {
    image_urls,
    catalog_id,
    title,
    subtitle,
    button_link_text,
    button_link_url
  } = _ref13;
  return {
    imageUrls: image_urls,
    catalogId: catalog_id,
    title,
    subtitle,
    buttonLinkText: button_link_text,
    buttonLinkUrl: button_link_url
  };
};
export const transformListerActivationBanners = banners => banners ? banners.map(transformListerActivationBanner) : [];
export const transformOnboardingModal = _ref14 => {
  let {
    name,
    steps
  } = _ref14;
  return {
    name,
    steps: steps.map(step => ({
      name: step.name,
      title: step.title,
      body: step.body,
      imageUrl: step.image_url,
      video: step.video && {
        vertical: {
          formats: step.video.vertical.formats,
          imageUrl: step.video.vertical.image_url
        }
      }
    })),
    isClosed: false
  };
};
export const transformBusinessAccountBanner = _ref15 => {
  let {
    title,
    body,
    cancel_button_label,
    continue_button_label,
    continue_button_url
  } = _ref15;
  return {
    title,
    body,
    cancelButtonLabel: cancel_button_label,
    continueButtonLabel: continue_button_label,
    continueButtonUrl: continue_button_url
  };
};
export const transformCatalogRulesBanner = _ref16 => {
  let {
    name,
    title,
    subtitle,
    action_title,
    action_url
  } = _ref16;
  return {
    name,
    title,
    subtitle,
    actionTitle: action_title,
    actionUrl: action_url
  };
};
export const transformFeaturedCollectionBanner = _ref17 => {
  let {
    name,
    title,
    subtitle,
    icon
  } = _ref17;
  return {
    name,
    title,
    subtitle,
    icon
  };
};
export const transformPortalMergeItemViewBanner = _ref18 => {
  let {
    cta_title,
    cta_url,
    bottom_text,
    bottom_text_link_title,
    bottom_text_link_url
  } = _ref18;
  return {
    ctaTitle: cta_title,
    ctaUrl: cta_url,
    bottomText: bottom_text,
    bottomTextLinkTitle: bottom_text_link_title,
    bottomTextLinkUrl: bottom_text_link_url
  };
};
export const transformTaxpayerBanner = _ref19 => {
  let {
    news_feed,
    type,
    title,
    body,
    version,
    actions,
    id
  } = _ref19;
  return {
    newsFeed: {
      dismissed: news_feed.dismissed,
      isDismissible: news_feed.is_dismissible,
      showModal: news_feed.show_modal
    },
    type,
    title,
    body,
    version,
    id,
    actions: actions === null || actions === void 0 ? void 0 : actions.map(action => ({
      title: action.title,
      link: action.link,
      type: action.type
    }))
  };
};
export const transformBanners = _ref20 => {
  let {
    closet_promotion,
    feed_personalization_banner,
    nps,
    email_confirmation,
    full_name_confirmation,
    push_up_banner,
    terms_and_conditions,
    portal_merge_feed,
    portal_merge_source_announcement,
    portal_merge_target_announcement,
    portal_merge_welcome_screen,
    portal_merge_data_migration,
    portal_merge_go_to_old_portal,
    portal_merge_wait_for_migration,
    portal_merge_initiate_from_target,
    lister_activation,
    onboarding_modal,
    business_account,
    category_intent_banner,
    catalog_rules,
    featured_collection_banner,
    portal_merge_item_view_banner,
    taxpayer_banner,
    forum_closure_banner
  } = _ref20;
  return {
    closetPromotion: closet_promotion && transformClosetPromoContainer(closet_promotion),
    feedPersonalizationBanner: feed_personalization_banner && transformFeedPersonalization(feed_personalization_banner),
    nps: nps && transformNps(nps),
    emailConfirmation: email_confirmation,
    fullNameConfirmation: full_name_confirmation && transformFullNameConfirmation(full_name_confirmation),
    pushUpBanner: push_up_banner && transformPushUp(push_up_banner),
    termsAndConditions: terms_and_conditions && transformTermsAndConditions(terms_and_conditions),
    portalMergeFeed: portal_merge_feed && transformPortalMergeFeed(portal_merge_feed),
    portalMergeSourceAnnouncement: portal_merge_source_announcement && transformPortalMergeAnnouncement(portal_merge_source_announcement),
    portalMergeTargetAnnouncement: portal_merge_target_announcement && transformPortalMergeAnnouncement(portal_merge_target_announcement),
    portalMergeWelcomeScreen: portal_merge_welcome_screen && transformMergeWelcomeScreen(portal_merge_welcome_screen),
    portalMergeDataMigration: portal_merge_data_migration && transformPortalMergeDataMigration(portal_merge_data_migration),
    portalMergeGoToOldPortalBannerModal: portal_merge_go_to_old_portal && transformGoToOldPortalBanner(portal_merge_go_to_old_portal),
    portalMergeWaitForMigrationModal: portal_merge_wait_for_migration && transformGoToOldPortalBanner(portal_merge_wait_for_migration),
    portalMergeInitiateFromTargetModal: portal_merge_initiate_from_target && transformGoToOldPortalBanner(portal_merge_initiate_from_target),
    listerActivation: transformListerActivationBanners(lister_activation),
    onboardingModal: onboarding_modal && transformOnboardingModal(onboarding_modal),
    businessAccount: business_account && transformBusinessAccountBanner(business_account),
    categoryIntentBanner: category_intent_banner,
    catalogRules: catalog_rules && transformCatalogRulesBanner(catalog_rules),
    featuredCollectionBanner: featured_collection_banner && transformFeaturedCollectionBanner(featured_collection_banner),
    portalMergeItemViewBanner: portal_merge_item_view_banner && transformPortalMergeItemViewBanner(portal_merge_item_view_banner),
    taxpayerBanner: taxpayer_banner && transformTaxpayerBanner(taxpayer_banner),
    forumClosureBanner: forum_closure_banner
  };
};